/**
 * Reg Exp Tester
 *
 * @param {RegExp} re - regular expression to convey test with
 * @returns {function(*=, *): boolean|*}
 * @throws TypeError
 */
export default re => (value, options) => (re.test(value) ? true : throw TypeError(options.error))
